import * as stylex from "@stylexjs/stylex";
import { colors, fonts, fontSizes } from "@softmax/design-system/tokens.stylex";

export function StorefrontRequirements({
  isMember,
  links = [],
}: {
  readonly isMember: boolean;
  readonly links?: readonly { readonly label: string; readonly href: string }[];
}) {
  if (isMember)
    return (
      <span {...stylex.props(styles.requirements)}>
        You&apos;re in — your players, rounds and replays are on your play page.
      </span>
    );

  if (links.length === 0) return null;

  return (
    <span {...stylex.props(styles.requirements)}>
      {links.map((link, index) => (
        <span key={link.label}>
          {index > 0 ? " · " : null}
          <a
            href={link.href}
            target={link.href.startsWith("http") ? "_blank" : undefined}
            rel={
              link.href.startsWith("http") ? "noopener noreferrer" : undefined
            }
            {...stylex.props(styles.requirement)}
          >
            {link.label}
          </a>
        </span>
      ))}
    </span>
  );
}
const styles = stylex.create({
  requirements: {
    fontFamily: fonts.sans,
    fontSize: fontSizes.caption,
    lineHeight: 1.333,
    color: colors.secondary,
    fontStyle: "italic",
  },
  requirement: {
    whiteSpace: "nowrap",
    fontStyle: "normal",
    color: colors.secondary,
    textDecoration: "underline",
  },
});
